import React from 'react';

import Box from '@mui/material/Box';

import Alert from '../common/Alert.jsx';
import PageLoading from '../common/PageLoading.jsx';
import ProductStatusHeader from './components/ProductStatusHeader.jsx';
import ProductStatusSection from './components/ProductStatusSection.jsx';
import useProductsOnBackOrderController from './hooks/useProductsOnBackOrderController.js';

const BACK_ORDER_COLUMNS = [
  { key: 'PartNo', label: 'Part No' },
  { key: 'Internal_Note', label: 'Internal Note' },
  { key: 'Customer_Note', label: 'Customer Note' },
  { key: 'Ship_Date', label: 'Ship Date' },
];

const DISCONTINUED_COLUMNS = [
  { key: 'PartNo', label: 'Part No' },
  { key: 'Internal_Note', label: 'Internal Note' },
];

function ProductsOnBackOrder() {
  const {
    search,
    backOrders,
    discontinued,
    counts,
    loading,
    errorMessage,
    setErrorMessage,
    handleSearchChange,
  } = useProductsOnBackOrderController();

  return (
    <Box sx={{ mx: '0.25rem', mb: '0.25rem', mt: '1rem', width: '100%' }}>
      {errorMessage && (
        <Alert
          data-cy="products-on-back-order-error"
          message={errorMessage}
          setMessage={setErrorMessage}
          level="error"
        />
      )}

      <ProductStatusHeader search={search} counts={counts} onSearchChange={handleSearchChange} />

      {loading ? (
        <Box sx={{ mt: 4, mb: 4 }}>
          <PageLoading />
        </Box>
      ) : (
        <>
          <ProductStatusSection
            title="Back Orders"
            dataCy="products-on-back-order-table"
            columns={BACK_ORDER_COLUMNS}
            rows={backOrders}
            emptyText="No back-order items found."
          />

          <ProductStatusSection
            title="Discontinued"
            dataCy="products-discontinued-table"
            columns={DISCONTINUED_COLUMNS}
            rows={discontinued}
            emptyText="No discontinued items found."
          />
        </>
      )}
    </Box>
  );
}

export default React.memo(ProductsOnBackOrder);
